<script lang="ts">
  export let name: string;
  export let value: string;
  export let active = false;
  export let required = true;
</script>

<div class="amount-button" on:click on:keypress role="button" tabindex="0">
  <input type="radio" {name} {value} checked={active} id="{name}-{value}" {required} />
  <label for="{name}-{value}">
    {value}&nbsp;Kč
  </label>
</div>

<style lang="scss">
  .amount-button {
    position: relative;
    input {
      position: absolute;
      top: 0;
      left: 50%;
      translate: -50% 0;
      opacity: 0;
      &:checked + label {
        background-color: $color-caramel;
        color: $color-white;
        border: none;
      }
    }
    label {
      height: 48px;
      border-radius: 16px;
      border: 1.5px solid $color-medium-gray;
      width: 100%;
      display: flex;
      align-items: center;
      place-content: center;
      cursor: pointer;
      transition: 0.2s ease all;
      &:hover {
        border-color: $color-caramel;
      }
    }
  }
</style>
